module.exports = __webpack_public_path__ + "static/image-02-13e4b40b9fe67a44ece7b1c1fb7cf8d7.jpg";